import { RolloutStatus } from "./api";

// Attribution is only carried by the entry the group currently points at, so it reads as noise
// ("deployer unknown") on statuses that were never going to have it.
export const isDeployTarget = (status: RolloutStatus) => status === "active" || status === "activating";

export const timeAgo = (iso: string) => {
  const seconds = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (seconds < 60) return "just now";
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return new Date(iso).toLocaleDateString();
};

type DeployAttribution = {
  deployed_by_email?: string | null;
  deployed_at?: string | null;
};

export const deployAttribution = ({ deployed_by_email, deployed_at }: DeployAttribution) => {
  if (deployed_by_email && deployed_at) return `by ${deployed_by_email} ${timeAgo(deployed_at)}`;
  if (deployed_by_email) return `by ${deployed_by_email}`;
  if (deployed_at) return `${timeAgo(deployed_at)}`;
  return "deployer unknown";
};
